import React, { useState, useEffect } from "react";
import { ModalBase, ImageOverlay } from "@reusejs/react";
import { StarIcon } from "@heroicons/react/outline";
import { getWatermarkedImgixUrl, shortlistProperty } from "services";
import { useSelector } from "react-redux";
import LoginModalComponent from "./propertyDetail/LoginModal";
import { useRouter } from "next/router";
import PropertyDetailCardWithoutTypesense from "./PropertyDetailCardWithoutTypesense";

export default function PropertyDetailWithImageWithoutTypesense(props: any) {
  const router = useRouter();
  const [interestedCount, setInterestedCount] = useState<number>(0);
  const userToken = useSelector((state: any) => state.auth.accessToken);
  const shortlistedProperties = useSelector(
    (state: any) => state.auth?.user?.profile?.meta?.shortlisted_properties,
  );

  useEffect(() => {
    if (props.property.interested_count) {
      setInterestedCount(props.property.interested_count);
    }
  }, [props.property.interested_count]);

  const cardWrapperClass = props.top
    ? "flex flex-col max-h"
    : "flex flex-row max-h";

  const imageWrapper = props.top
    ? "h-40 rounded-t-xl bg-cover"
    : "rounded-l-xl object-cover";

  const LoginModalWrapper = (props: any) => {
    return (
      <LoginModalComponent
        heading="Login to shortlist"
        subHeading="Please login or create account to shortlist."
        description="Property shortlist is only available to Auction bazaar users."
        router={router}
        {...props}
      />
    );
  };

  const openModal = async () => {
    await ModalBase(
      {
        content: LoginModalWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "z-50  overflow-visible",
          padding: "p-0",
          small: "max-w-4xl",
        },
      },
      1000,
      "__next",
    );
  };

  const handleShortListed = async (event: React.MouseEvent, uuid: string) => {
    event.stopPropagation();
    try {
      if (userToken) {
        const data: any = await shortlistProperty(
          uuid,
          props.property.interested_count,
        );
        setInterestedCount(data.interested_count);
      } else {
        openModal();
      }
    } catch (error) {
      console.log("check error", error);
    }
  };

  const handleCardClick = () => {
    window.open(`/auction-properties/${props.property?.listing_id}`, "_blank");
  };

  const iconClasses =
    shortlistedProperties && shortlistedProperties.includes(props.property.uuid)
      ? "text-blue-600 font-bold cursor-pointer hover:text-blue-600"
      : "text-white font-bold cursor-pointer hover:text-blue-600";
  const fillValue =
    shortlistedProperties && shortlistedProperties.includes(props.property.uuid)
      ? "currentColor"
      : "none";

  const ListingIdBadge = () => (
    <div className="absolute top-0.5 left-2 bg-blue-600 text-white text-xs font-medium px-2 py-1 rounded">
      ID: {props.property?.listing_id}
    </div>
  );

  // console.log("property name ----------------------------.......>>>>", props.property.dump.asset.asset_type_name)

  return (
    <div
      key={props.id}
      className={
        "w-max relative bg-white border border-gray-200 rounded-xl shadow-sm flex flex-col hover:shadow-lg transition-shadow duration-300 cursor-pointer " +
        props.marginClass
      }
      onClick={handleCardClick}
    >
      <div className={cardWrapperClass}>
        <div
          className={`${imageWrapper} ${props.widthClass} relative overflow-hidden`}
        >
          {props.property?.images && props.property?.images.length > 0 ? (
            <ImageOverlay
              src={getWatermarkedImgixUrl(
                `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${props.property?.images[0].key_path}?fit=crop&w=${props.width}&h=${props.height}&auto=format`,
              )}
              width={props.width}
              height={props.height}
              placeholderSrc={
                props?.property?.dump?.asset?.asset_type_name === "residential"
                  ? getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/5f5054dc-b5b5-44c8-8c0e-e90b981f17de?fit=crop&w=${props.width}&h=${props.height}&auto=format`,
                    )
                  : props.property?.asset?.name === "commercial"
                  ? getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/1d41376d-0203-4311-9533-40198e5f8c35?fit=crop&w=${props.width}&h=${props.height}&auto=format`,
                    )
                  : getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/96512031-3c35-47ae-bbf3-757336f15530?fit=crop&w=${props.width}&h=${props.height}&auto=format`,
                    )
              }
              topRight={
                <StarIcon
                  width="24"
                  height="24"
                  className={iconClasses}
                  fill={fillValue}
                  onClick={(e) => handleShortListed(e, props.property.uuid)}
                />
              }
              topLeft={<ListingIdBadge />}
              effectClasses={
                props.top
                  ? "rounded-t-xl inset-0 bg-gradient-to-b from-gray-600 opacity-40"
                  : "rounded-l-xl inset-0 bg-gradient-to-b from-gray-600 opacity-40"
              }
              altName={`auction-property-${props.property?.images[0].key_path}`}
            />
          ) : (
            <ImageOverlay
              src={
                props?.property?.dump?.asset?.asset_type_name === "residential"
                  ? getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/5f5054dc-b5b5-44c8-8c0e-e90b981f17de?fit=crop&w=${props.width}&h=${props.height}&auto=format`,
                    )
                  : props?.property?.dump?.asset?.asset_type_name ===
                    "commercial"
                  ? getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/1d41376d-0203-4311-9533-40198e5f8c35?fit=crop&w=${props.width}&h=${props.height}&auto=format`,
                    )
                  : getWatermarkedImgixUrl(
                      `${process.env.NEXT_PUBLIC_IMAGIX_URL_STATIC}/96512031-3c35-47ae-bbf3-757336f15530?fit=crop&w=${props.width}&h=${props.height}&auto=format`,
                    )
              }
              width={props.width}
              height={props.height}
              topRight={
                <StarIcon
                  width="24"
                  height="24"
                  className={iconClasses}
                  fill={fillValue}
                  onClick={(e) => handleShortListed(e, props.property.uuid)}
                />
              }
              topLeft={<ListingIdBadge />}
              effectClasses={
                props.top
                  ? "rounded-t-xl inset-0 bg-gradient-to-b from-gray-600 opacity-40"
                  : "rounded-l-xl inset-0 bg-gradient-to-b from-gray-600 opacity-40"
              }
              altName="auction-property"
            />
          )}
        </div>
        <PropertyDetailCardWithoutTypesense
          borderClasses={props.top ? "rounded-b-xl" : "rounded-r-xl"}
          widthClasses={props.widthClass}
          interestedCount={interestedCount}
          {...props}
        />
      </div>
    </div>
  );
}
